import * as React from 'react';
import AdditionalImageForm from "../../components/AdditionalImages/AdditionalImageForm/AdditionalImageForm";
var AdditionalImage = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5 offset-md-4" },
                    React.createElement(AdditionalImageForm, null))))));
};
export default AdditionalImage;



//////////////////
// WEBPACK FOOTER
// ./src/views/AdditionalImages/AdditionalImage.tsx
// module id = 239
// module chunks = 0